// extracted by mini-css-extract-plugin
module.exports = {"page-banner":"pages_page-banner__2SvXp","modal-video":"pages_modal-video__53l3x"};